export interface RestaurantStaffingDefaults {
  servers: number;
  lineCooks: number;
  prepCooks: number;
  dishwashers: number;
  hosts: number;
  kitchenManagers: number;
  generalManagers: number;
}

export function calculateRestaurantStaffingDefaults(seatsInput: number): RestaurantStaffingDefaults {
  const seats = Math.min(Math.max(1, Math.round(Number(seatsInput) || 1)), 600);
  const lineCooks = Math.min(Math.max(1, Math.ceil(seats / 22)), 8);

  return {
    servers: Math.min(Math.max(1, Math.ceil(seats / 18)), 12),
    lineCooks,
    prepCooks: Math.max(1, Math.ceil(lineCooks * 0.75)),
    dishwashers: Math.max(1, Math.ceil(seats / 40)),
    hosts: seats >= 80 ? 2 : 1,
    kitchenManagers: seats >= 100 ? 2 : 1,
    generalManagers: 1,
  };
}

export function isRestaurantStaffingConcept(businessType: string | undefined): boolean {
  return ["restaurant", "brunch-spot"].includes((businessType || "").toLowerCase());
}